import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType,
} from 'app/enums/label.enums'
import {
    kamToBeCompleted,
} from '../KamDashboard.types'

const kamDashboardConfig: SkyNetTableConfig<keyof kamToBeCompleted> = {
    name: 'kamToBeCompleted',
    tabs: [{
        name: 'To Be Awarded/Rejected',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'quoteNumber',
                labelKey: 'AccountQuotes.quoteNumber',
            },
            {
                name: 'customerQuotationLocationName',
                labelKey: 'AccountQuotes.customerQuotation',
            },
            {
                name: 'accountName',
                labelKey: 'AccountLane.accountCompanyName',
                filterField: 'accountName',
                filterType: FilterType.Array,
            },
            {
                name: 'leaseType',
                labelKey: 'AccountLane.leaseType',
                filterField: 'leaseType',
                componentName: 'EnumValue',
                filterType: FilterType.Array,
                allowedValuesEnum: LeaseType,
            },
            {
                name: 'originAirport',
                labelKey: 'AccountLane.originAirport',
                componentName: 'List',
                filterField: 'originAirport',
                filterType: FilterType.Array,
                sorting: false,
            },
            {
                name: 'destinationAirport',
                labelKey: 'AccountLane.destinationAirport',
                componentName: 'List',
                filterField: 'destinationAirport',
                filterType: FilterType.Array,
                sorting: false,
            },
            {
                name: 'pricingResponsible',
                labelKey: 'AccountQuotes.pricingResponsible',
                componentName: 'List',
            },
            {
                name: 'createdBy',
                labelKey: 'KamDashboard.requestor',
                sorting: false,
            },
            {
                name: 'upcomingLanes',
                labelKey: 'KamDashboard.upcomingLanes',
                sorting: false,
            },
            {
                name: 'pricedLanes',
                labelKey: 'KamDashboard.pricedLanes',
                sorting: false,
            },
            {
                name: 'completedLanes',
                labelKey: 'KamDashboard.completedLanes',
                sorting: false,
            },
            {
                name: 'lastUpdated',
                labelKey: 'KamDashboard.lastUpdated',
                sorting: false,
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default kamDashboardConfig
